import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import { submitEarlySettlementApi } from '../../utils/apisConsts';
import { SubmitEarlySettlement } from './SubmitEarlySettlement';

export const ViewSubmitEarlySettlement: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Get User',
            content: <GetInfo apiLink={submitEarlySettlementApi} isApplyingPhoneAndID/>,
            id: 0,
        },
        {
            title: 'Submit Early Settlement',
            content: <SubmitEarlySettlement />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

